import Logger from './Logger';
import GlobalData from './GlobalData';

class PostMessageUtil {
    // Singleton
    static instance;

    static incomingMessageCallback;

      // Message Types sent from Clients
      INCOMING_MESSAGES_TYPE = {
        INITIAL_DATA: 'adbmsgui_INITIAL_DATA',
        WINDOW_OPENED: 'adbmsgui_WINDOW_OPENED',
        CUSTOMER_AUTH_DATA_RESPONSE: 'adbmsgui_CUSTOMER_AUTH_DATA_RESPONSE',
      };

      // Message Types sent to Clients
      OUTGOING_MESSAGES_TYPE = {
        CONV_STARTED: 'adbmsg_CONV_STARTED',
        CONV_CLOSED: 'adbmsg_CONV_CLOSED',
        NEW_MESSAGE: 'adbmsg_NEW_MESSAGE',
        MINIMIZE_WINDOW: 'adbmsg_MINIMIZE_WINDOW',
        EXPAND_WINDOW: 'adbmsg_EXPAND_WINDOW',
        INITIAL_DATA_HANDLED: 'adbmsg_INITIAL_DATA_HANDLED',
        CUSTOMER_AUTH_DATA_REQUEST: 'adbmsg_CUSTOMER_AUTH_DATA_REQUEST',
        FILE_DOWNLOAD: 'adbmsg_FILE_DOWNLOAD',
      };

      constructor() {
        if (this.instance) return this.instance;

        this.instance = this;
        this.incomingMessageCallback = [];
        this.messageOrigin = '';
        this.messageTargetOrigin = '';
      }

      get incomingMessageTypes() {
        return this.INCOMING_MESSAGES_TYPE;
      }

      get outgoingMessageTypes() {
        return this.OUTGOING_MESSAGES_TYPE;
      }

      addIncomingMessageCallback(msgType, callback) {
        this.incomingMessageCallback.push({
          msgType,
          callback,
        });
      }

      static verifyData(event, messageOrigin) {
        // const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        let data;
        try {
            data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        } catch (e) {
            Logger.debug('Invalid JSON format in event data');
            return false;
        }
        if (!(typeof data === 'object' && data.msgType)) {
          return false;
        }
        if (event.origin !== messageOrigin
          || !data.msgType.startsWith('adbmsgui_')) {
          return false;
        }

        return true;
      }

      incomingMessageHandler(_hashData) {
        this.messageOrigin = _hashData.window_origin;
        this.messageTargetOrigin = _hashData.iframe_origin || _hashData.window_origin;
        GlobalData.setPopped(_hashData.popped);

        function receiveMessage(event) {
          if (PostMessageUtil.verifyData(event, this.messageOrigin)) {
            // const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            let data;
            try {
                data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            } catch (e) {
                Logger.debug('Invalid JSON format in event data');
                return false;
            }
            Logger.debug(`Message callback: ${data}`);

            const callobj = this.incomingMessageCallback
              .find((callbackObj) => callbackObj.msgType === data.msgType);
            if (callobj) {
              const messageCallback = callobj.callback;
              if (messageCallback) {
                messageCallback(data.msgType, data.message, event.source);
              } else {
                Logger.debug(`Callback for this message not found: ${data.msgType}`);
              }
            } else {
              Logger.debug(`Callback for this message not found: ${data.msgType}`);
            }
          }
        }

        window.addEventListener('message', receiveMessage.bind(this), false);
      }

      sendMessage(msgType, message = null) {
        const targetOrigin = this.messageOrigin;

        try {
          if (!this.window) {
            window.parent.postMessage({ msgType, message }, targetOrigin);
          }
        } catch (e) {
          Logger.debug('Postmessage - unable to send');
        }
      }
}

const instance = new PostMessageUtil();
export default instance;
